module.exports = __webpack_public_path__ + "img/photo_b.3cd7ceea.svg";